import { API_URLS } from "../constants";
import { postRequest, putRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { SURVEY } = API_URLS;

//Get survey preferences that user have saved
const getSurveyPreferences = (encryptedParams) => {
  return postRequest(SURVEY.USER_NOTIFICATION_PREFERENCES, encryptedParams).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Update survey preferences
const updateSurveyPreferences = (body) => {
  return putRequest(SURVEY.USER_NOTIFICATION_PREFERENCES, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//exporting functions for other files
export const changeSurveyPreferencesService = {
  getSurveyPreferences,
  updateSurveyPreferences,
};
